module.exports = __webpack_public_path__ + "assets/d5369f46d719ec5b4727acacaf7c91fc.png";